import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';

import React from 'react';
import { useNavigate } from 'react-router-dom';

import AppWrapper from '../../components/appWrapper/appWrapper';
import useScrollToLocation from '../../hooks/useScrollToLocation';
import Faqs from './components/faqs/faqs';
import { FeaturesSection } from './components/featuresSection/featuresSection';
import HeroSection from './components/heroSection/heroSection';
import { HighlevelBenefits } from './components/highlevelBenefits/highlevelBenefits';
import { SignUpProcess } from './components/signUpProcess/signUpProcess';
import { CompetitorTestimoninal } from './components/testimoninal/testimoninal';

interface BusinessCompetitorProps {
  heroConfig: any;
  testimoninalConfig: any;
  faqsConfig: any;
  featuresTitle: string;
  featuresTiles: any;
  highlevelBenefitsConfig: any;
  heroColor: string;
}

export const LearnMoreButton = () => {
  const navigate = useNavigate();

  const handleNavigateToPataPay = () => {
    navigate('/business/pata-pay');
  };

  return <Button onClick={handleNavigateToPataPay}>Learn more</Button>;
};

export const BusinessCompetitor = ({
  heroConfig,
  testimoninalConfig,
  faqsConfig,
  featuresTitle,
  featuresTiles,
  signUpProcessTitle,
  testimoninalTitle,
  testimoninalSubTitle,
  highlevelBenefitsConfig,
  heroColor,
}: BusinessCompetitorProps) => {
  useScrollToLocation();

  return (
    <>
      <AppWrapper>
        <HeroSection config={heroConfig} heroColor={heroColor} />
        <WidthContainer>
          <></>
        </WidthContainer>

        <HighlevelBenefits config={highlevelBenefitsConfig} />

        <CompetitorTestimoninal
          config={testimoninalConfig}
          testimoninalTitle={testimoninalTitle}
          testimoninalSubTitle={testimoninalSubTitle}
        />
        <FeaturesSection featuresTitle={featuresTitle} featuresTiles={featuresTiles} />

        <SignUpProcess signUpProcessTitle={signUpProcessTitle} />

        <Faqs config={faqsConfig} />
      </AppWrapper>
    </>
  );
};
